import { useChatBootstrap } from '@/hooks/useChatBootstrap'
import { useAgentRuntime, useAgentStore } from '@/context/AgentProvider'
import { ChatHistory } from './ChatHistory'

interface ChatHistoryPanelProps {
  loadChats?: boolean
  multiUser?: boolean
}

const ChatHistoryPanel = ({ loadChats = true, multiUser = false }: ChatHistoryPanelProps) => {
  const runtime = useAgentRuntime()
  const isOpen = useAgentStore((state) => state.isChatHistoryOpen)
  const showHistory = runtime.config.features?.historySidebar !== false
  const chatsQuery = useChatBootstrap({ enabled: loadChats && showHistory, multiUser })

  if (!showHistory || !isOpen) {
    return null
  }

  return (
    <div className='mp-agent-chat-history-panel'>
      <ChatHistory
        fetchNextPage={chatsQuery.fetchNextPage}
        hasNextPage={chatsQuery.hasNextPage}
        isFetchingNextPage={chatsQuery.isFetchingNextPage}
      />
    </div>
  )
}

export default ChatHistoryPanel
